import { render, staticRenderFns } from "./RenovacionRapidaComponent.vue?vue&type=template&id=fbec0ed2&scoped=true"
import script from "./RenovacionRapidaComponent.vue?vue&type=script&lang=js"
export * from "./RenovacionRapidaComponent.vue?vue&type=script&lang=js"
import style0 from "./RenovacionRapidaComponent.vue?vue&type=style&index=0&id=fbec0ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbec0ed2",
  null
  
)

export default component.exports